module.exports = __webpack_public_path__ + "static/media/kimi.93965aca.svg";